export default __webpack_public_path__ + "static/media/bg-main.5141a0b2.webp";